export default function getResource(label, vars = []) {
    const resources = {
        share: 'Partager',
        sharePost: 'Partager la publication',
        shareProfile: 'Partager le profil',
        shareProduct: 'Partager l’essentiel',
        shareCollection: 'Partager la collection',
        copyLinkText: 'Copiez le lien suivant et partagez-le avec vos ami(e)s :',
        copy: 'Copier',
        copied: 'Copié!',
        allProducts: 'Tous les produits',
        featuredHeader: 'Offres en vedette',
        featured: 'Offres en vedette',
        products: 'Produits',
        collections: 'Collections',
        posts: 'Publications',
        viewDetails: 'Voir les détails',
        showMoreCollections: 'Afficher plus de collections',
        items: 'articles',
        addToBasket: 'Ajouter au panier',
        moreFrom: 'Plus de',
        viewAll: 'Tout afficher',
        shopWith: 'Magasiner avec',
        goToStorefront: 'Visiter la vitrine',
        defaultDisplayName: 'Créateur',
        seoPageTitle: `Vitrine virtuelle Sephora de ${vars[0]} | Sephora`,
        seoPageTitleProducts: `Vitrine virtuelle Sephora de ${vars[0]} – Essentiels | Sephora`,
        seoPageTitleCollections: `Vitrine virtuelle Sephora de ${vars[0]} – Collections | Sephora`,
        seoMetaDescription: `Vous cherchez les favoris Sephora de ${vars[0]}? Visiter la vitrine virtuelle Sephora de ${vars[0]} pour obtenir une liste de recommandations d’essentiels et de collections.`,
        postsOf: `Publications de ${vars[0]}`,
        commissionableLinks: 'Contient des liens donnant droit à commission'
    };

    return resources[label];
}
